import { NewQuestionList } from './NewQuestionList';
export default NewQuestionList;
